import { Component } from '@angular/core';

@Component({
  selector: 'gymfinder-empty-route',
  template: '',
})
export class EmptyRouteComponent {}
